import { observer } from 'mobx-react'

import { ZaiIcon } from 'assets/icons/zai'
import { PanelStore } from 'stores'

import { useZaiSideChatButtonModel } from './zai-side-chat-button.model'
import { ZaiSideChatButtonView } from './zai-side-chat-button.view'

import './zai-side-chat-button.styles.scss'

const Component = () => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.panelId

  const zaiSideChatButtonModel = useZaiSideChatButtonModel()

  if (!workspaceId) return null

  return <ZaiSideChatButtonView {...zaiSideChatButtonModel} IconComponent={ZaiIcon} />
}

export const ZaiSideChatButton = observer(Component)
